import { Routes, Route } from "react-router-dom";
import { TermValidationList } from "@/pages/financial/term-validation/list";
import { ViewTermValidation } from "@/pages/financial/term-validation/view";

export default function TermRequestsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<TermValidationList />} />
      <Route path="/visualizar/:id" element={<ViewTermValidation />} />
    </Routes>
  );
}
